module.exports = __webpack_public_path__ + "img/電気回路_1_9.72bd20eb.png";